import { useEffect, useRef } from 'react';
import { NotificationsByConsumer } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import {
    NotificationsByConsumerQueryVariables,
    useNotificationQuery,
} from './useNotificationQuery';

export const useNotification = ({
    variables,
    onError,
}: {
    variables: NotificationsByConsumerQueryVariables;
    onError?: () => void;
}): {
    notification: NotificationsByConsumer['firstNotification'] | undefined;
} => {
    const { notification, errors } = useNotificationQuery(variables);

    const isOnErrorCalled = useRef(false);

    useEffect(() => {
        if (errors && onError && !isOnErrorCalled.current) {
            onError();

            isOnErrorCalled.current = true;
        }
    }, [errors, onError]);

    return {
        notification,
    };
};
